/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: "BPSK-20" | "OQPSK-RC-200" }} Brmodrf_Values2Inputs */



/**
* | value | output |
* | --- | --- |
* | "BPSK-20" | "Robust (used during radio interference)" |
* | "OQPSK-RC-200" | "Fast (recommended)" |
*
* @param {Brmodrf_Values2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const brmodrf_values2 = /** @type {((inputs: Brmodrf_Values2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brmodrf_Values2Inputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.value === "BPSK-20") return /** @type {LocalizedString} */ (`Robust (used during radio interference)`);
		if (i?.value === "OQPSK-RC-200") return /** @type {LocalizedString} */ (`Fast (recommended)`);
		return /** @type {LocalizedString} */ ("brModRf_values");
	}
	{
		if (i?.value === "BPSK-20") return /** @type {LocalizedString} */ (`Robuste (utilisé lors d'interférence radio)`);
		if (i?.value === "OQPSK-RC-200") return /** @type {LocalizedString} */ (`Rapide (recommandé)`);
		return /** @type {LocalizedString} */ ("brModRf_values");
	}
});
export { brmodrf_values2 as "brModRf_values" }